import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = ["id"]

import { computed, inject, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import CopyableLink from '@/components/neue/CopyableLink.vue'
import StoreActions from '@/components/neue/StoreActions'
import StoreAvailability from '@/components/neue/StoreAvailability'
import StoreBasics from '@/components/neue/StoreBasics'
import StoreCategories from '@/components/neue/StoreCategories'
import StoreDiscountLimit from '@/components/neue/StoreDiscountLimit'
import StoreFees from '@/components/neue/StoreFees'
import StoreFulfillment from '@/components/neue/StoreFulfillment'
import StoreInvoicing from '@/components/neue/StoreInvoicing'
import StoreMembershipTiers from '@/components/neue/StoreMembershipTiers'
import StoreMinimums from '@/components/neue/StoreMinimums'
import StorePackages from '@/components/neue/StorePackages'
import StorePermissions from '@/components/neue/StorePermissions'
import StorePopups from '@/components/neue/StorePopups'
import StorePricingTiers from '@/components/neue/StorePricingTiers'
import StoreQuestions from '@/components/neue/StoreQuestions'
import StoreReceipt from '@/components/neue/StoreReceipt'
import StoreSelection from '@/components/neue/StoreSelection'
import StoreSignup from '@/components/neue/StoreSignup'
import StoreTaxes from '@/components/neue/StoreTaxes'
import StoreTipping from '@/components/neue/StoreTipping'
import StoreUpsells from '@/components/neue/StoreUpsells'
import { hasMembershipProgram } from '@/config/membershipTierView'
import {
  buildStoreEditorSections,
  buildStoreTabs,
  resolveStoreTab,
  storeTabForAnchor,
  storeTabPath
} from '@/config/storeEditorSections'
import { hasInvoicing } from '@/helpers/invoicing'
import { mapRelationship } from '@/store/mappers'
import StoreSectionCard from '@/view/store/StoreSectionCard.vue'

// onBeforeRouteLeave(() => {
//   if (hasUnsavedChanges) {
//     vLocal.modal.type = 'confirmCancelChangesStoreModal'
//     return false
//   } else return true
// })

// const handleConfirmCancelChanges = () => {
//   hasUnsavedChanges = false
//   router.push('/store/stores')
// }

const CARD = 'max-w-[1040px]'
const WIDE_CARD = 'max-w-[1180px]'


export default {
  __name: 'StoreNeue',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const hasUnsavedChanges = ref(false)
const currentStore = computed(() => mapRelationship({ type: 'store', id: route.params.id }))
const name = computed(() => currentStore.value?.attributes.store_name)
const link = computed(() => currentStore.value?.attributes.store_link)
const isCateringStore = computed(() => currentStore.value?.attributes?.platform === 'catering')

const handle = computed(
  () => store.state.loggedInUser.attributes?.user_name || store.state.loggedInUser.attributes?.handle
)

const hasAnnouncements = computed(() => store.state.loggedInUser?.attributes?.capabilities?.includes('announcements'))
const canInvoice = computed(() => hasInvoicing(store.state.loggedInUser))
const hasMembershipTiers = computed(() => hasMembershipProgram(store.state.loggedInUser))

const sections = computed(() =>
  buildStoreEditorSections({
    hasAnnouncements: hasAnnouncements.value,
    handle: handle.value,
    isCatering: isCateringStore.value,
    canInvoice: canInvoice.value,
    hasMembershipTiers: hasMembershipTiers.value
  })
)

const activeTab = computed(() => resolveStoreTab(sections.value, route.params.tab))

const storeTabs = computed(() =>
  buildStoreTabs({ sections: sections.value, storeId: route.params.id, activeTab: activeTab.value }).map(tab => ({
    ...tab,
    action: () => router.push(tab.to)
  }))
)

const childContent = computed(() => ({
  basics: { is: StoreBasics, bare: true },
  access: { is: StorePermissions, bare: true },
  'selection-settings': { is: StoreSelection, bare: true },
  'questions-before-selection': { is: StoreQuestions, bare: true, props: { when: 'before_selection' } },
  categories: { is: StoreCategories, bare: true },
  availability: { is: StoreAvailability, bare: true },
  upsells: { is: StoreUpsells, bare: true },
  minimums: { is: StoreMinimums, bare: true },
  'pricing-tiers': { is: StorePricingTiers, bare: true, wide: true },
  'discount-limit': { is: StoreDiscountLimit, bare: true },
  packages: { is: StorePackages, bare: true },
  'sign-up-explanation': { is: StoreSignup, bare: true, props: { only: 'explanation' } },
  'new-sign-up-automation': { is: StoreSignup, bare: true, props: { only: 'automation' } },
  announcements: { is: StorePopups },
  'questions-before-checkout': { is: StoreQuestions, bare: true, props: { when: 'before_checkout' } },
  fulfillment: { is: StoreFulfillment, bare: true, wide: true },
  'membership-tiers': { is: StoreMembershipTiers, bare: true },
  tipping: { is: StoreTipping, bare: true },
  invoicing: { is: StoreInvoicing, bare: true },
  taxes: { is: StoreTaxes, bare: true },
  'merchant-fee': { is: StoreFees, bare: true, props: { only: 'merchant' } },
  'bottle-fees': { is: StoreFees, bare: true, props: { only: 'bottle' } },
  'receipt-settings': { is: StoreReceipt, bare: true, props: { only: 'settings' } },
  'paid-bottle-automation': { is: StoreReceipt, bare: true, props: { only: 'automation' } },
  'questions-after-checkout': { is: StoreQuestions, bare: true, props: { when: 'after_checkout' } },
  actions: { is: StoreActions, bare: true, props: { name: name.value, isCatering: isCateringStore.value } }
}))

const sectionContent = computed(() =>
  sections.value.map(section => ({
    link: section.link,
    children: section.children
      .filter(child => childContent.value[child.link])
      .map(child => ({ link: child.link, content: childContent.value[child.link] }))
  }))
)

const footerWidth = computed(() =>
  sectionContent.value.find(section => section.link === activeTab.value)?.children.some(child => child.content.wide)
    ? WIDE_CARD
    : CARD
)

const scrollToHash = () => {
  const anchor = route.hash?.replace(/^#/, '')
  if (!anchor) return
  const owner = storeTabForAnchor(sections.value, anchor)
  if (owner && owner !== activeTab.value) router.replace(storeTabPath(route.params.id, owner) + route.hash)
  let attempts = 0
  const tryScroll = () => {
    const el = document.getElementById('linkable-' + anchor)
    if (el?.offsetParent) el.scrollIntoView({ behavior: 'smooth' })
    else if (attempts++ < 20) setTimeout(tryScroll, 150)
  }
  tryScroll()
}

onMounted(scrollToHash)

const bus = inject('bus')
bus.on('dirty/store', () => {
  hasUnsavedChanges.value = true
})

const handleDiscardChanges = async () => {
  bus.emit('discard/store')
  hasUnsavedChanges.value = false
}

const handleSubmit = () => {
  bus.emit('save/store')
  hasUnsavedChanges.value = false
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: name.value,
        "save-status": true,
        sections: storeTabs.value
      }, {
        right: _withCtx(() => [
          (link.value)
            ? (_openBlock(), _createBlock(CopyableLink, {
                key: 0,
                link: link.value,
                class: "ml-4"
              }, null, 8, ["link"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["text", "sections"])
    ]),
    main: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        key: _unref(route).params.id,
        class: "flex flex-col justify-between min-h-full"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectionContent.value, (section) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: section.link
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.children, (child) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: child.link,
                  class: _normalizeClass(["border-t border-[#e4e7eb] first:border-t-0", child.content.wide ? WIDE_CARD : CARD])
                }, [
                  _createElementVNode("div", {
                    id: 'linkable-' + child.link
                  }, null, 8, _hoisted_2),
                  (child.content.bare)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(child.content.is), _mergeProps({
                        key: 0,
                        id: _unref(route).params.id
                      }, { ref_for: true }, child.content.props ?? {}), null, 16, ["id"]))
                    : (_openBlock(), _createBlock(StoreSectionCard, {
                        key: 1,
                        class: "my-7"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(child.content.is), _mergeProps({
                            id: _unref(route).params.id
                          }, { ref_for: true }, child.content.props ?? {}), null, 16, ["id"]))
                        ]),
                        _: 2
                      }, 1024))
                ], 2))
              }), 128))
            ])), [
              [_vShow, section.link === activeTab.value]
            ])
          }), 128))
        ]),
        _createVNode(_component_PageFooter, {
          sticky: "",
          "content-width": footerWidth.value
        }, {
          right: _withCtx(() => [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "btn-ghost mr-3",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = $event => (handleDiscardChanges()))
                  }, "Discard"),
                  _createElementVNode("button", {
                    class: "btn-primary",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = $event => (handleSubmit()))
                  }, "Save")
                ], 64))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "btn-primary",
                  type: "button",
                  to: "/store/stores"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Done", -1)
                  ]))]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["content-width"])
      ]))
    ]),
    _: 1
  }))
}
}

}